import { useStableCallback } from "@bezoned/shared/hooks/use-stable-callback.js";
import { Switch } from "@fluentui/react-components";

import { useJoinChimeStore } from "../../notifications/join-chime.store.js";

export const SettingsUserNotifications = () => {
  const { enabled, setEnabled } = useJoinChimeStore();
  const handleChange14 = useStableCallback((_, data) =>
    setEnabled(data.checked)
  );

  return (
    <ul className="flex w-full flex-col space-y-6">
      <li className="flex items-center">
        <span className="text-sm font-medium">Join table chime</span>
        <Switch
          checked={enabled}
          className="ml-auto"
          onChange={handleChange14}
        />
      </li>
    </ul>
  );
};
